const MapOverlay = ({ children }) => (
    <div className="absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm">
        {children}
    </div>
);

export default MapOverlay;


